import React from "react";

import { useForm } from "react-hook-form";
import { useMutation } from "@apollo/client";
import { useState } from "react";
import Loader from "../../components/loader/loader";
import { toastFunction, errorToastFunction } from "../../utils/toast";
import FloatingLabelInput from "../FloatingLabelInput/FloatingLabelInput";
import { CREATE_PACKAGE_MUTATION } from "../../graphql/mutations/createPackage";

const AddPackage = ({ onCancel }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {},
  });

  const [createPackage, { loading }] = useMutation(CREATE_PACKAGE_MUTATION);

  const [errorMessage, setErrorMessage] = useState(null);

  const onSubmit = async (data) => {
    const packageData = {
      name: data.name,
      price: parseFloat(data.price),
      limit_mamps: parseFloat(data.limit_mamps),
      limit_dailywh: parseFloat(data.limit_dailywh),
      reset_time: parseFloat(data.reset_time),
    };
    try {
      setErrorMessage("");
      const { data } = await createPackage({
        variables: { packageData: packageData },
      });
      toastFunction(
        `Successfully created package with name ${data.createPackage.package.name}.`,
        "success",
        "package-create-success"
      );
      onCancel();

      reset();
    } catch (error) {
      console.error("Create package error:", error);

      let displayError = "Failed to create package. Please try again.";

      if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        displayError = error.graphQLErrors[0].message;
      } else if (error.networkError) {
        displayError = `Network error: ${error.networkError.message}`;
      } else if (error.message) {
        displayError = error.message;
      }

      setErrorMessage(displayError);
      errorToastFunction(displayError, "package-create-error");
    }
  };

  if (loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>Add Package</h3>
      </div>
      <div className="basic-modal__body">
        {errorMessage && (
          <div
            className="input-container__error"
            style={{
              marginBottom: "20px",
              padding: "12px",
              backgroundColor: "#ffebee",
              border: "1px solid #ef5350",
              borderRadius: "4px",
              color: "#c62828",
              fontSize: "14px",
              lineHeight: "1.5",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {errorMessage}
          </div>
        )}
        <form onSubmit={handleSubmit(onSubmit)} className="basic-modal__form">
          <FloatingLabelInput
            type={"text"}
            className={""}
            disabled={false}
            name={"name"}
            register={register}
            rules={{ required: "The name field is required." }}
            placeholder={"Name"}
            errors={errors}
          />

          <FloatingLabelInput
            type={"number"}
            className={""}
            disabled={false}
            name={"price"}
            register={register}
            rules={{ required: "The price field is required." }}
            placeholder={"Price"}
            errors={errors}
          />

          <FloatingLabelInput
            type={"number"}
            className={""}
            disabled={false}
            name={"limit_dailywh"}
            register={register}
            rules={{ required: "The Daily Limit field is required." }}
            placeholder={"Daily Limit"}
            errors={errors}
          />

          <FloatingLabelInput
            type={"number"}
            className={""}
            disabled={false}
            name={"limit_mamps"}
            register={register}
            rules={{ required: "The Currency Limit field is required." }}
            placeholder={"Currency Limit"}
            errors={errors}
          />

          <FloatingLabelInput
            type={"number"}
            className={""}
            disabled={false}
            name={"reset_time"}
            register={register}
            rules={{ required: "The Reset Time field is required." }}
            placeholder={"Reset Time"}
            errors={errors}
          />

          <div className="basic-modal__footer">
            <button onClick={onCancel} className="button button--secondary">
              Cancel
            </button>
            <button type="submit" className="button button--primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPackage;
